import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import { URL } from "../../api.jsx";
import getPrivilegeList from "../PrivilegeList.jsx";

const Agent = () => {
  const privilegeList = getPrivilegeList();

  /* ===================== LIST STATE ===================== */
  const [agents, setAgents] = useState([]);

  /* ===================== DROPDOWNS ===================== */
  const [companyList, setCompanyList] = useState([]);
  const [branchDropdown, setBranchDropdown] = useState([]);

  /* ===================== FILTER STATE ===================== */
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  /* ===================== PAGINATION ===================== */
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  /* ===================== FETCH COMPANIES ===================== */
  const fetchCompanies = async () => {
    try {
      const res = await axiosInstance.get(URL.COMPANY_LIST_BY_CODE);
      setCompanyList(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Company dropdown error:", err);
      setCompanyList([]);
    }
  };

  /* ===================== FETCH BRANCH DROPDOWN ===================== */
  const fetchBranchesDropdown = async () => {
    try {
      const res = await axiosInstance.get(URL.COMPANY_BRANCH);
      setBranchDropdown(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Branch dropdown error:", err);
      setBranchDropdown([]);
    }
  };

  /* ===================== FETCH AGENT LIST ===================== */
  const fetchAgents = async () => {
    try {
      const lsCompanyCode = localStorage.getItem("companyCode");
      const lsBranchCode = localStorage.getItem("branch_code");

      const params = new URLSearchParams();

      // Restrict to logged-in user's company + branch when both exist
      if (lsCompanyCode && lsBranchCode && lsBranchCode !== "null") {
        params.append("companyCode", lsCompanyCode);
        params.append("branchCode", lsBranchCode);
      } else {
        if (selectedCompany) params.append("companyCode", selectedCompany);
        if (selectedBranch) params.append("branchCode", selectedBranch);
      }

      if (mobileNumber) params.append("mobileNumber", mobileNumber);

      const res = await axiosInstance.get(
        `${URL.GET_ALL_AGENT}?${params.toString()}`
      );

      setAgents(
  Array.isArray(res.data)
    ? res.data.filter((a) => a && a.id)
    : []
);
      setCurrentPage(1);
    } catch (err) {
      console.error("Fetch agents error:", err);
      setAgents([]);
    }
  };

  /* ===================== INIT ===================== */
  useEffect(() => {
    fetchCompanies();
    fetchBranchesDropdown();
    fetchAgents();
  }, []);

  /* ===================== PAGINATION ===================== */
  const totalPages = Math.ceil(agents.length / rowsPerPage);
  const paginatedAgents = agents.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="container">
      {/* ===================== HEADER ===================== */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Agent List</h3>

        {privilegeList.agentAdd && (
          <button
            className="btn btn-sm btn-success"
            onClick={() => (window.location.href = "#/AgentAddEdit")}
          >
            + Add Agent
          </button>
        )}
      </div>

      {/* ===================== FILTER SECTION ===================== */}
      <div className="card p-3 mb-4">
        <div className="row gx-2 gy-2 align-items-end">
          {/* Company */}
          <div className="col-auto">
            <label className="form-label">Company</label>
            <select
              className="form-select form-select-sm"
              value={selectedCompany}
              onChange={(e) => {
                setSelectedCompany(e.target.value);
                setSelectedBranch("");
              }}
            >
              <option value="">All</option>
              {companyList.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.value}
                </option>
              ))}
            </select>
          </div>

          {/* Branch – only after company */}
          {selectedCompany && (
            <div className="col-auto">
              <label className="form-label">Branch</label>
              <select
                className="form-select form-select-sm"
                value={selectedBranch}
                onChange={(e) => setSelectedBranch(e.target.value)}
              >
                <option value="">All</option>
                {branchDropdown
                  .filter(
                    (b) =>
                      String(b.companyCode) === String(selectedCompany)
                  )
                  .map((b) => (
                    <option key={b.branchCode} value={b.branchCode}>
                      {b.branchName}
                    </option>
                  ))}
              </select>
            </div>
          )}

          {/* Mobile Number */}
          <div className="col-auto">
            <label className="form-label">Mobile</label>
            <input
              className="form-control form-control-sm"
              placeholder="Mobile Number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
          </div>

          <div className="col-auto">
            <button
              className="btn btn-sm btn-primary"
              onClick={fetchAgents}
            >
              Search
            </button>
          </div>
        </div>
      </div>

      {/* ===================== TABLE ===================== */}
      <div className="table-responsive" style={{ whiteSpace: "nowrap" }}>
        <table className="table table-sm table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>Agent Name</th>
              <th>Company</th>
              <th>Branch</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Status</th>
              <th>Registered Date</th>
              {privilegeList.agentEdit && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {paginatedAgents.length > 0 ? (
              paginatedAgents.map((a, i) => (
                <tr key={a.id}>
                  <td>
                    {(currentPage - 1) * rowsPerPage + i + 1}
                  </td>
                  <td>{a.agentName}</td>
                  <td>{a.companyName || "-"}</td>
                  <td>{a.branchName || "-"}</td>
                  <td>{a.email}</td>
                  <td>{a.phoneNumber}</td>
                  <td>
                    <span
                      className={`badge rounded-pill ${
                        a.status === "ACTIVE"
                          ? "bg-success"
                          : "bg-secondary"
                      }`}
                    >
                      {a.status}
                    </span>
                  </td>
                  <td>{a.createdAt ? String(a.createdAt).replace("T", " ").slice(0, 19) : "-"}</td>

                  {privilegeList.agentEdit && (
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          (window.location.href = `#/AgentAddEdit?id=${a.id}`)
                        }
                      >
                        Edit
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center text-muted">
                  No agents found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ===================== PAGINATION ===================== */}
      {agents.length > rowsPerPage && (
        <div className="d-flex justify-content-center mt-3">
          <div className="d-flex align-items-center gap-1">
            <button
              className="btn btn-sm btn-outline-primary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={`btn btn-sm ${
                  currentPage === i + 1
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-sm btn-outline-primary"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Agent;